import { defineMessages } from 'react-intl';

export default defineMessages({
  bundleItemCount: {
    id: 'BundleOptions.bundleItem.count',
    description: 'Simple translation of "of" word in counting bundle items',
    defaultMessage: '{optionNumber} of {total}',
  },
  bundleIncludedSectionTitle: {
    id: 'BundleOptions.bundleIncludedSectionTitle',
    description: 'Title for What\'s Included section',
    defaultMessage: 'What\'s Included',
  },
});
